/**
 * Resolve company logo URL. Uses override if provided, else in dev a local path,
 * else the canonical CDN URL so production always gets the correct asset
 * regardless of where the widget script is hosted (avoids script-path derivation).
 */

const LOGO_FILENAME = 'bostello_mail_logo.webp'
const PRODUCTION_LOGO_URL = 'https://cdn.platform.bostello.com/assets/bostello_mail_logo.webp'

export function captureScriptBase(): void {
  if (typeof document === 'undefined') return
  const script = document.currentScript as HTMLScriptElement | null
  if (script?.src) {
    const lastSlash = script.src.lastIndexOf('/')
    const base = lastSlash >= 0 ? script.src.slice(0, lastSlash + 1) : script.src
    ;(window as any).__bostContactMeScriptBase = base
  }
}

export function getWidgetLogoUrl(override?: string): string {
  if (override && override.trim()) return override.trim()
  // In dev, use path from origin so Vite serves public/bostello_mail_logo.webp
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    return '/' + LOGO_FILENAME
  }
  // Production: always use canonical CDN URL (no derivation from script path)
  return PRODUCTION_LOGO_URL
}
